// Button labels for the POS refund screen. The server applies the same
// rules again in server/src/services/orderRefundMath.js and ignores any
// dollar amount from the client.

function money(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return 0;
  return Math.round(x * 100) / 100;
}

function basePaymentMethod(method) {
  if (method === 'cash_refunded') return 'cash';
  if (method === 'card_refunded') return 'card_paid';
  if (method === 'split_refunded') return 'split';
  return method;
}

function initialQuantities(lines) {
  const quantities = {};
  for (const line of lines || []) {
    if (line.refundable_quantity > 0) quantities[line.id] = line.refundable_quantity;
  }
  return quantities;
}

function selectionFromQuantities(lines, quantities) {
  const requested = [];
  let total = 0;
  for (const line of lines || []) {
    const quantity = Number(quantities?.[line.id] || 0);
    if (!Number.isInteger(quantity) || quantity <= 0) continue;
    const capped = Math.min(quantity, line.refundable_quantity);
    if (capped <= 0) continue;
    const amount = money(money(line.unit_price) * capped);
    total = money(total + amount);
    requested.push({ order_item_id: line.id, quantity: capped });
  }
  return { requested, total: money(total) };
}

function planRefundTender({ paymentMethod, total, cashRemaining, cardRemaining, prefer }) {
  const amount = money(total);
  const cash = money(Math.max(0, Number(cashRemaining) || 0));
  const card = money(Math.max(0, Number(cardRemaining) || 0));
  if (amount <= 0) return { error: 'Select at least one item to refund' };

  if (paymentMethod === 'cash') {
    if (amount - cash > 0.009) return { error: `Cash can refund up to $${cash.toFixed(2)}` };
    return { cash: amount, card: 0, mode: 'cash' };
  }
  if (paymentMethod === 'card_paid') {
    if (amount - card > 0.009) return { error: `Card can refund up to $${card.toFixed(2)}` };
    return { cash: 0, card: amount, mode: 'card' };
  }
  if (paymentMethod === 'split') {
    const pool = money(cash + card);
    if (amount - pool > 0.009) return { error: `This order can refund up to $${pool.toFixed(2)}` };
    const cashCovers = amount - cash <= 0.009;
    const cardCovers = amount - card <= 0.009;
    if (prefer === 'cash') {
      if (!cashCovers) {
        return { error: `Cash can refund up to $${cash.toFixed(2)}. Untick items or refund to the card.` };
      }
      return { cash: amount, card: 0, mode: 'cash' };
    }
    if (prefer === 'card') {
      if (!cardCovers) {
        return { error: `Card can refund up to $${card.toFixed(2)}. Untick items or refund as cash.` };
      }
      return { cash: 0, card: amount, mode: 'card' };
    }
    if (prefer === 'both') {
      if (cashCovers || cardCovers) return { error: 'Choose cash or card for this refund' };
    } else if (cashCovers && cardCovers) {
      return { needs_choice: true, cash: amount, card: amount, mode: 'choice' };
    } else if (cardCovers) {
      return { cash: 0, card: amount, mode: 'card' };
    } else if (cashCovers) {
      return { cash: amount, card: 0, mode: 'cash' };
    }
    const cashPart = money(Math.min(cash, amount));
    const cardPart = money(amount - cashPart);
    if (cardPart - card > 0.009) return { error: `This order can refund up to $${pool.toFixed(2)}` };
    return { cash: cashPart, card: cardPart, mode: 'both' };
  }
  return { error: 'This order was not paid at the counter, so it cannot be refunded here' };
}

module.exports = {
  money,
  basePaymentMethod,
  initialQuantities,
  selectionFromQuantities,
  planRefundTender,
};
